import { Tooltip, Box, Spinner, Text } from '@chakra-ui/react'
import { useState } from 'react'
import { useServiceProtocol } from '../../hooks/useServiceProtocol'

type Props = {
  serviceId: number
  children: React.ReactNode
  title?: string
}

export function ServiceProtocolTooltip({ serviceId, title, children }: Props) {
  const { getProtocol } = useServiceProtocol()
  const [content, setContent] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  async function handleOpen() {
    if (content || loading) return

    setLoading(true)
    const protocol = await getProtocol(serviceId)
    setContent(protocol)
    setLoading(false)
  }

  return (
    <Tooltip
      label={
        <Box maxW="320px">
          {!!title && (
            <Text fontSize="sm" fontWeight="semibold">
              {title}
            </Text>
          )}
          {loading && <Spinner size="sm" />}

          {!loading && content && (
            <Box
              fontSize="sm"
              lineHeight="1.6"
              dangerouslySetInnerHTML={{ __html: content }}
              sx={{
                ul: {
                  pl: '18px',
                  mt: 2
                },
                li: {
                  mb: 1
                },
                strong: {
                  color: 'green.300'
                }
              }}
            />
          )}
        </Box>
      }
      hasArrow
      bg="gray.800"
      color="white"
      borderRadius="md"
      p={3}
      onOpen={handleOpen}
    >
      <Box cursor="pointer">{children}</Box>
    </Tooltip>
  )
}
